module.exports = __webpack_public_path__ + "img/my_grey.1a75a7d9.svg";